// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-wrapper {
  min-height: 100vh;
  padding: 40px 15px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.profile-card {
  width: 100%;
  max-width: 900px;
  background: #ffffff;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 20px 45px rgba(28, 72, 143, 0.15);
  animation: cardFade 0.6s ease;
}

.profile-top {
  position: relative;
  text-align: center;
  padding: 55px 20px 30px;
  overflow: hidden;
}
.profile-top .profile-bg {
  position: absolute;
  inset: 0;
  height: 120px;
  background: rgba(0, 71, 171, 0.431372549);
  animation: gradientMove 5s ease infinite alternate;
}
.profile-top h3 {
  position: relative;
  margin-top: 15px;
  margin-bottom: 4px;
  font-weight: 800;
  color: #222;
}
.profile-top p {
  position: relative;
  margin: 0;
  color: #6c757d;
  font-weight: 600;
}

.profile-avatar {
  position: relative;
  z-index: 2;
  width: 105px;
  height: 105px;
  margin: auto;
  border-radius: 50%;
  background: #ffffff;
  border: 5px solid #ffffff;
  box-shadow: 0 10px 25px rgba(13, 110, 253, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: floatAvatar 3s ease-in-out infinite;
}
.profile-avatar i {
  font-size: 58px;
  color: #0d6efd;
}

.profile-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  padding: 0 20px 25px;
}
.profile-actions button {
  border: none;
  border-radius: 12px;
  padding: 10px 18px;
  font-weight: 700;
  transition: all 0.25s ease;
}
.profile-actions button i {
  margin-right: 7px;
}
.profile-actions button:hover {
  transform: translateY(-2px);
}

.btn-edit {
  background: #0d6efd;
  color: #fff;
}

.btn-save {
  background: #198754;
  color: #fff;
}

.btn-cancel {
  background: #dc3545;
  color: #fff;
}

.profile-form {
  padding: 0 30px 30px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
}

.form-group {
  animation: inputFade 0.45s ease;
}
.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #495057;
  margin-bottom: 7px;
}
.form-group input {
  width: 100%;
  height: 46px;
  border: 1px solid #dce3ef;
  border-radius: 13px;
  padding: 0 14px;
  font-weight: 600;
  outline: none;
  transition: all 0.25s ease;
  background: #ffffff;
}
.form-group input:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.12);
}
.form-group input:disabled {
  background: #f8f9fb;
  color: #6c757d;
  cursor: not-allowed;
}

.input-icon {
  position: relative;
}
.input-icon i {
  position: absolute;
  top: 70%;
  left: 14px;
  transform: translateY(-50%);
  color: #0d6efd;
  font-size: 20px;
}
.input-icon input {
  padding-left: 46px;
}

.password-toggle {
  padding: 0 30px 30px;
}
.password-toggle button {
  width: 100%;
  border: 1px dashed #0d6efd;
  background: #f4f8ff;
  color: #0d6efd;
  border-radius: 15px;
  padding: 13px 18px;
  font-weight: 800;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  transition: all 0.25s ease;
}
.password-toggle button:hover {
  background: #e9f2ff;
  transform: scale(1.01);
}

.password-box {
  margin: 0 30px 30px;
  padding: 22px;
  border-radius: 18px;
  background: #fbfcff;
  border: 1px solid #edf1f7;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  animation: slideDown 0.35s ease;
}

.btn-password {
  grid-column: 1/-1;
  justify-self: end;
  border: none;
  background: #ffc107;
  color: #222;
  padding: 11px 18px;
  border-radius: 12px;
  font-weight: 800;
  transition: all 0.25s ease;
}
.btn-password i {
  margin-right: 7px;
}
.btn-password:hover {
  transform: translateY(-2px);
  background: #ffca2c;
}

@keyframes cardFade {
  from {
    opacity: 0;
    transform: translateY(25px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes floatAvatar {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-7px);
  }
}
@keyframes inputFade {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes gradientMove {
  from {
    filter: hue-rotate(0deg);
  }
  to {
    filter: hue-rotate(25deg);
  }
}
@media (max-width: 768px) {
  .profile-form,
  .password-box {
    grid-template-columns: 1fr;
  }
  .profile-card {
    border-radius: 18px;
  }
  .profile-actions {
    flex-direction: column;
  }
  .profile-actions button {
    width: 100%;
  }
}
.password-strength {
  margin-top: 10px;
}
.password-strength .strength-bar {
  height: 8px;
  border-radius: 20px;
  transition: all 0.4s ease;
  animation: strengthPulse 0.5s ease;
}
.password-strength .strength-bar.weak {
  width: 33%;
  background: #dc3545;
}
.password-strength .strength-bar.medium {
  width: 66%;
  background: #ffc107;
}
.password-strength .strength-bar.strong {
  width: 100%;
  background: #198754;
}
.password-strength .strength-text {
  display: inline-block;
  margin-top: 6px;
  font-size: 13px;
  font-weight: 700;
}
.password-strength .strength-text.weak {
  color: #dc3545;
}
.password-strength .strength-text.medium {
  color: #ffc107;
}
.password-strength .strength-text.strong {
  color: #198754;
}

@keyframes strengthPulse {
  from {
    transform: scaleX(0);
    opacity: 0;
  }
  to {
    transform: scaleX(1);
    opacity: 1;
  }
}
.password-match {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  font-size: 13px;
  font-weight: 700;
  animation: fadeInMatch 0.3s ease;
}
.password-match i {
  font-size: 15px;
}
.password-match.match {
  color: #198754;
}
.password-match.not-match {
  color: #dc3545;
}

@keyframes fadeInMatch {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.password-last-updated {
  grid-column: 1/-1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  margin-top: 5px;
  background: linear-gradient(135deg, #f8f9ff, #eef4ff);
  border: 1px solid #dbe7ff;
  border-left: 4px solid #0d6efd;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #495057;
  animation: fadeInPasswordInfo 0.4s ease;
}
.password-last-updated i {
  font-size: 18px;
  color: #0d6efd;
}
.password-last-updated strong {
  margin-left: 6px;
  color: #212529;
  font-weight: 700;
}

@keyframes fadeInPasswordInfo {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.demo-banner {
  margin: 20px 30px;
  padding: 14px 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  background: linear-gradient(135deg, #fff8e7, #fff3cd);
  border: 1px solid #ffe69c;
  border-left: 5px solid #ff9800;
  border-radius: 14px;
  animation: slideBanner 0.4s ease;
}
.demo-banner i {
  font-size: 28px;
  color: #ff9800;
  flex-shrink: 0;
}
.demo-banner h6 {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: #7a4e00;
}
.demo-banner p {
  margin: 2px 0 0;
  font-size: 13px;
  color: #856404;
}

@keyframes slideBanner {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/ProfilePage/ProfilePage.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,kBAAA;EAEA,aAAA;EACA,uBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,+CAAA;EACA,6BAAA;AAAF;;AAGA;EACE,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;AAAF;AAEE;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EAEA,yCAAA;EACA,kDAAA;AADJ;AAIE;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAFJ;AAKE;EACE,kBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gDAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8CAAA;AAJF;AAME;EACE,eAAA;EACA,cAAA;AAJJ;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,oBAAA;AALF;AAOE;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;AALJ;AAOI;EACE,iBAAA;AALN;AAQI;EACE,2BAAA;AANN;;AAWA;EACE,mBAAA;EACA,WAAA;AARF;;AAWA;EACE,mBAAA;EACA,WAAA;AARF;;AAWA;EACE,mBAAA;EACA,WAAA;AARF;;AAWA;EACE,oBAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AARF;;AAWA;EACE,+BAAA;AARF;AAUE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AARJ;AAWE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,0BAAA;EACA,mBAAA;AATJ;AAWI;EACE,qBAAA;EACA,8CAAA;AATN;AAYI;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;AAVN;;AAeA;EACE,kBAAA;AAZF;AAcE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;AAZJ;AAeE;EACE,kBAAA;AAbJ;;AAiBA;EACE,oBAAA;AAdF;AAgBE;EACE,WAAA;EACA,0BAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,0BAAA;AAdJ;AAgBI;EACE,mBAAA;EACA,sBAAA;AAdN;;AAmBA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;EACA,+BAAA;AAhBF;;AAmBA;EACE,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;AAhBF;AAkBE;EACE,iBAAA;AAhBJ;AAmBE;EACE,2BAAA;EACA,mBAAA;AAjBJ;;AAqBA;EACE;IACE,UAAA;IACA,uCAAA;EAlBF;EAoBA;IACE,UAAA;IACA,iCAAA;EAlBF;AACF;AAqBA;EACE;IAEE,wBAAA;EApBF;EAuBA;IACE,2BAAA;EArBF;AACF;AAwBA;EACE;IACE,UAAA;IACA,0BAAA;EAtBF;EAyBA;IACE,UAAA;IACA,wBAAA;EAvBF;AACF;AA0BA;EACE;IACE,UAAA;IACA,4BAAA;EAxBF;EA2BA;IACE,UAAA;IACA,wBAAA;EAzBF;AACF;AA4BA;EACE;IACE,wBAAA;EA1BF;EA6BA;IACE,yBAAA;EA3BF;AACF;AA8BA;EACE;;IAEE,0BAAA;EA5BF;EA+BA;IACE,mBAAA;EA7BF;EAgCA;IACE,sBAAA;EA9BF;EAgCE;IACE,WAAA;EA9BJ;AACF;AAmCA;EACE,gBAAA;AAjCF;AAmCE;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kCAAA;AAjCJ;AAmCI;EACE,UAAA;EACA,mBAAA;AAjCN;AAoCI;EACE,UAAA;EACA,mBAAA;AAlCN;AAqCI;EACE,WAAA;EACA,mBAAA;AAnCN;AAuCE;EACE,qBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AArCJ;AAuCI;EACE,cAAA;AArCN;AAwCI;EACE,cAAA;AAtCN;AAyCI;EACE,cAAA;AAvCN;;AA4CA;EACE;IACE,oBAAA;IACA,UAAA;EAzCF;EA4CA;IACE,oBAAA;IACA,UAAA;EA1CF;AACF;AA6CA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AA3CF;AA6CE;EACE,eAAA;AA3CJ;AA8CE;EACE,cAAA;AA5CJ;AA+CE;EACE,cAAA;AA7CJ;;AAiDA;EACE;IACE,UAAA;IACA,2BAAA;EA9CF;EAiDA;IACE,UAAA;IACA,wBAAA;EA/CF;AACF;AAkDA;EACE,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,SAAA;EAEA,kBAAA;EACA,eAAA;EAEA,qDAAA;EACA,yBAAA;EACA,8BAAA;EACA,mBAAA;EAEA,eAAA;EACA,gBAAA;EACA,cAAA;EAEA,uCAAA;AArDF;AAuDE;EACE,eAAA;EACA,cAAA;AArDJ;AAwDE;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;AAtDJ;;AA0DA;EACE;IACE,UAAA;IACA,2BAAA;EAvDF;EA0DA;IACE,UAAA;IACA,wBAAA;EAxDF;AACF;AA4DA;EACE,iBAAA;EACA,kBAAA;EAEA,aAAA;EACA,mBAAA;EACA,SAAA;EAEA,qDAAA;EACA,yBAAA;EACA,8BAAA;EACA,mBAAA;EAEA,gCAAA;AA7DF;AA+DE;EACE,eAAA;EACA,cAAA;EACA,cAAA;AA7DJ;AAgEE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA9DJ;AAiEE;EACE,eAAA;EACA,eAAA;EACA,cAAA;AA/DJ;;AAmEA;EACE;IACE,UAAA;IACA,4BAAA;EAhEF;EAmEA;IACE,UAAA;IACA,wBAAA;EAjEF;AACF","sourcesContent":[".profile-wrapper {\n  min-height: 100vh;\n  padding: 40px 15px;\n//   background: linear-gradient(135deg, #eef4ff, #f8fbff);\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.profile-card {\n  width: 100%;\n  max-width: 900px;\n  background: #ffffff;\n  border-radius: 24px;\n  overflow: hidden;\n  box-shadow: 0 20px 45px rgba(28, 72, 143, 0.15);\n  animation: cardFade 0.6s ease;\n}\n\n.profile-top {\n  position: relative;\n  text-align: center;\n  padding: 55px 20px 30px;\n  overflow: hidden;\n\n  .profile-bg {\n    position: absolute;\n    inset: 0;\n    height: 120px;\n    // background: linear-gradient(135deg, #0d6efd, #6f42c1);\n    background: #0047ab6e;\n    animation: gradientMove 5s ease infinite alternate;\n  }\n\n  h3 {\n    position: relative;\n    margin-top: 15px;\n    margin-bottom: 4px;\n    font-weight: 800;\n    color: #222;\n  }\n\n  p {\n    position: relative;\n    margin: 0;\n    color: #6c757d;\n    font-weight: 600;\n  }\n}\n\n.profile-avatar {\n  position: relative;\n  z-index: 2;\n  width: 105px;\n  height: 105px;\n  margin: auto;\n  border-radius: 50%;\n  background: #ffffff;\n  border: 5px solid #ffffff;\n  box-shadow: 0 10px 25px rgba(13, 110, 253, 0.25);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  animation: floatAvatar 3s ease-in-out infinite;\n\n  i {\n    font-size: 58px;\n    color: #0d6efd;\n  }\n}\n\n.profile-actions {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  padding: 0 20px 25px;\n\n  button {\n    border: none;\n    border-radius: 12px;\n    padding: 10px 18px;\n    font-weight: 700;\n    transition: all 0.25s ease;\n\n    i {\n      margin-right: 7px;\n    }\n\n    &:hover {\n      transform: translateY(-2px);\n    }\n  }\n}\n\n.btn-edit {\n  background: #0d6efd;\n  color: #fff;\n}\n\n.btn-save {\n  background: #198754;\n  color: #fff;\n}\n\n.btn-cancel {\n  background: #dc3545;\n  color: #fff;\n}\n\n.profile-form {\n  padding: 0 30px 30px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 18px;\n}\n\n.form-group {\n  animation: inputFade 0.45s ease;\n\n  label {\n    display: block;\n    font-size: 14px;\n    font-weight: 700;\n    color: #495057;\n    margin-bottom: 7px;\n  }\n\n  input {\n    width: 100%;\n    height: 46px;\n    border: 1px solid #dce3ef;\n    border-radius: 13px;\n    padding: 0 14px;\n    font-weight: 600;\n    outline: none;\n    transition: all 0.25s ease;\n    background: #ffffff;\n\n    &:focus {\n      border-color: #0d6efd;\n      box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.12);\n    }\n\n    &:disabled {\n      background: #f8f9fb;\n      color: #6c757d;\n      cursor: not-allowed;\n    }\n  }\n}\n\n.input-icon {\n  position: relative;\n\n  i {\n    position: absolute;\n    top: 70%;\n    left: 14px;\n    transform: translateY(-50%);\n    color: #0d6efd;\n    font-size: 20px;\n  }\n\n  input {\n    padding-left: 46px;\n  }\n}\n\n.password-toggle {\n  padding: 0 30px 30px;\n\n  button {\n    width: 100%;\n    border: 1px dashed #0d6efd;\n    background: #f4f8ff;\n    color: #0d6efd;\n    border-radius: 15px;\n    padding: 13px 18px;\n    font-weight: 800;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    transition: all 0.25s ease;\n\n    &:hover {\n      background: #e9f2ff;\n      transform: scale(1.01);\n    }\n  }\n}\n\n.password-box {\n  margin: 0 30px 30px;\n  padding: 22px;\n  border-radius: 18px;\n  background: #fbfcff;\n  border: 1px solid #edf1f7;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n  animation: slideDown 0.35s ease;\n}\n\n.btn-password {\n  grid-column: 1 / -1;\n  justify-self: end;\n  border: none;\n  background: #ffc107;\n  color: #222;\n  padding: 11px 18px;\n  border-radius: 12px;\n  font-weight: 800;\n  transition: all 0.25s ease;\n\n  i {\n    margin-right: 7px;\n  }\n\n  &:hover {\n    transform: translateY(-2px);\n    background: #ffca2c;\n  }\n}\n\n@keyframes cardFade {\n  from {\n    opacity: 0;\n    transform: translateY(25px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes floatAvatar {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-7px);\n  }\n}\n\n@keyframes inputFade {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-12px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes gradientMove {\n  from {\n    filter: hue-rotate(0deg);\n  }\n\n  to {\n    filter: hue-rotate(25deg);\n  }\n}\n\n@media (max-width: 768px) {\n  .profile-form,\n  .password-box {\n    grid-template-columns: 1fr;\n  }\n\n  .profile-card {\n    border-radius: 18px;\n  }\n\n  .profile-actions {\n    flex-direction: column;\n\n    button {\n      width: 100%;\n    }\n  }\n}\n\n\n.password-strength {\n  margin-top: 10px;\n\n  .strength-bar {\n    height: 8px;\n    border-radius: 20px;\n    transition: all 0.4s ease;\n    animation: strengthPulse 0.5s ease;\n\n    &.weak {\n      width: 33%;\n      background: #dc3545;\n    }\n\n    &.medium {\n      width: 66%;\n      background: #ffc107;\n    }\n\n    &.strong {\n      width: 100%;\n      background: #198754;\n    }\n  }\n\n  .strength-text {\n    display: inline-block;\n    margin-top: 6px;\n    font-size: 13px;\n    font-weight: 700;\n\n    &.weak {\n      color: #dc3545;\n    }\n\n    &.medium {\n      color: #ffc107;\n    }\n\n    &.strong {\n      color: #198754;\n    }\n  }\n}\n\n@keyframes strengthPulse {\n  from {\n    transform: scaleX(0);\n    opacity: 0;\n  }\n\n  to {\n    transform: scaleX(1);\n    opacity: 1;\n  }\n}\n\n.password-match {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 8px;\n  font-size: 13px;\n  font-weight: 700;\n  animation: fadeInMatch 0.3s ease;\n\n  i {\n    font-size: 15px;\n  }\n\n  &.match {\n    color: #198754;\n  }\n\n  &.not-match {\n    color: #dc3545;\n  }\n}\n\n@keyframes fadeInMatch {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.password-last-updated {\n  grid-column: 1 / -1;\n\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  padding: 12px 16px;\n  margin-top: 5px;\n\n  background: linear-gradient(135deg, #f8f9ff, #eef4ff);\n  border: 1px solid #dbe7ff;\n  border-left: 4px solid #0d6efd;\n  border-radius: 12px;\n\n  font-size: 14px;\n  font-weight: 600;\n  color: #495057;\n\n  animation: fadeInPasswordInfo 0.4s ease;\n\n  i {\n    font-size: 18px;\n    color: #0d6efd;\n  }\n\n  strong {\n    margin-left: 6px;\n    color: #212529;\n    font-weight: 700;\n  }\n}\n\n@keyframes fadeInPasswordInfo {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n\n.demo-banner {\n  margin: 20px 30px;\n  padding: 14px 18px;\n\n  display: flex;\n  align-items: center;\n  gap: 14px;\n\n  background: linear-gradient(135deg, #fff8e7, #fff3cd);\n  border: 1px solid #ffe69c;\n  border-left: 5px solid #ff9800;\n  border-radius: 14px;\n\n  animation: slideBanner 0.4s ease;\n\n  i {\n    font-size: 28px;\n    color: #ff9800;\n    flex-shrink: 0;\n  }\n\n  h6 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 800;\n    color: #7a4e00;\n  }\n\n  p {\n    margin: 2px 0 0;\n    font-size: 13px;\n    color: #856404;\n  }\n}\n\n@keyframes slideBanner {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
